import { useRouter } from 'next/router';
import PersonHero from '@/shared/assets/svg/modal-person.svg';
import AccountIdInput, {
  useAccountIdInputControls,
} from '@/shared/components/dashboards/AccountIdInput';
import { DashboardModal } from '@/shared/components/dashboards/Modal';
import Button from '@/shared/components/flip-ui-kit/Button';
import { type ChainflipNetwork, getChainflipNetwork } from '@/shared/utils/env';

const defaultAccountIds: Partial<Record<ChainflipNetwork, string>> = {
  backspin: 'cFPdef3hF5zEwbWUG6ZaCJ3X7mTvEeAog7HxZ8QyFcCgDVGDM', // bouncer lp 1
  sisyphos: 'cFKSFcF57NfUVuwLPkCmQ2vF11RQ28gPn7yiLnnTswUtmVcAu', // niklas
  perseverance: 'cFJ4ELogY7gXLueJGZaQUyTC8582ntbKtNw1V7arieyv1Wk5Z', // idk? but its the only account with a boost position
  mainnet: 'cFLTUvyYwfZBLjCuLP6G8t85qW3FDmzSD3WPYq249EhP3Zs9g', // david
};
export const defaultAccountId = defaultAccountIds[getChainflipNetwork()];

const ViewOnlyAccountModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const router = useRouter();
  const controls = useAccountIdInputControls(defaultAccountId);

  return (
    <DashboardModal open={open} onClose={onClose}>
      <div className="relative flex h-full w-[512px] flex-col justify-between gap-6 rounded-md border border-cf-gray-4 bg-cf-gray-3 p-6">
        <div className="flex justify-between">
          <div className="flex flex-col gap-2">
            <span className="font-aeonikMedium text-16 text-cf-white">View-only mode</span>
            <div className="max-w-xs text-14 text-cf-light-2">
              Enter a Chainflip account ID to try out the liquidity provision app in view-only mode.
            </div>
          </div>
          <PersonHero className="pointer-events-none fixed right-0 top-0" />
        </div>
        <div className="flex flex-col gap-y-4">
          <AccountIdInput {...controls} />
        </div>
        <div className="flex items-center gap-x-2 self-end justify-self-end">
          <Button className="max-w-fit" type="secondary-standard" onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            className="max-w-fit"
            type="primary-standard"
            onClick={() => {
              router.replace({ query: { ...router.query, accountId: controls.accountId } });
              onClose();
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </DashboardModal>
  );
};

export default ViewOnlyAccountModal;
